import axios from 'axios';
import TokenService from './authentication/token.service';
import { getAPIBaseURL } from '../utilities/BaseURLUtility';
import ApiAnalyticsService from './userAnalytics/apiAnalytics.service';

const baseUrl = getAPIBaseURL();
const wellControlUrl = getAPIBaseURL('wellcontrolapi');
const userURL = getAPIBaseURL('usersapi');
const pumpcheckerUrl = getAPIBaseURL('pumpchecker');
const realTimeApiUrl = getAPIBaseURL('realtimedataapi');

const userInstance = axios.create({
  baseURL: userURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const pumpCheckerInstance = axios.create({
  baseURL: pumpcheckerUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const wellControlInstance = axios.create({
  baseURL: wellControlUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const realTimeApiInstance = axios.create({
  baseURL: realTimeApiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Initialize API Analytics
const analyticsService = ApiAnalyticsService.getInstance();
analyticsService.attachToAxiosInstance(instance);
analyticsService.attachToAxiosInstance(userInstance);
analyticsService.attachToAxiosInstance(wellControlInstance);
analyticsService.attachToAxiosInstance(pumpCheckerInstance);
analyticsService.attachToAxiosInstance(realTimeApiInstance);

userInstance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

wellControlInstance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

realTimeApiInstance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

pumpCheckerInstance.interceptors.request.use(
  (config: any) => {
    const correlationId = TokenService.getCorrelationId();
    if (correlationId) {
      config.headers['xspoc-ui-tracking-id'] = correlationId;
    }

    const token = process.env.REACT_APP_PUMPCHECKER_TOKEN;

    if (token) {
      // If the token exists, set the Authorization header to 'Bearer <token>'
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

userInstance.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error) {
    handelUnauthorized(error);

    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error) {
    console.log('URL', error?.config?.url);
    // Handle Pump Checker (PC) token expiration (logout & redirect)
    const isForbidden = error?.response?.status === 403 && error?.config?.url?.includes('/Router/Router');
    if (isForbidden) {
      TokenService.removeUser();
      if (window.location.pathname !== '/login') {
        window.location.reload();
      }
    }
    handelUnauthorized(error);

    return Promise.reject(error);
  },
);

realTimeApiInstance.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error) {
    handelUnauthorized(error);

    return Promise.reject(error);
  },
);

wellControlInstance.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error) {
    handelUnauthorized(error);

    return Promise.reject(error);
  },
);

const handelUnauthorized = (error: any) => {
  if (error.response.status === 401) {
    TokenService.removeUser();

    if (window.location.pathname !== '/login') {
      window.location.reload();
    }
  }
};

export default instance;
export { wellControlInstance, userInstance, pumpCheckerInstance, realTimeApiInstance, analyticsService };
